
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CalculatorRatio',
  data() {
    return {
      width: '',
      height: '',
      ratio: '',
    };
  },
  methods: {
    calculateRatio() {
      // TODO: validate inputs
      if (!this.height || !this.width) return;

      const width = parseInt(this.width, 10);
      const height = parseInt(this.height, 10);
      const ratio = this.gcd(width, height);
      this.ratio = `${width / ratio}:${height / ratio}`;
    },
    gcd(a: number, b: number): number {
      return (b === 0) ? a : this.gcd(b, a % b);
    },
    resetForm() {
      this.width = '';
      this.height = '';
      this.ratio = '';
    },
  },
});
